export function calculatePrice(form) {
  const m2 = form.area;
  let netto = m2 * 370000; // Alapár - lapos tetős

  // Nyeregtető felár
  if (form.roof === "gable") {
    netto += m2 * 50000;
  }

  // ÁFA kulcs (5% vagy 27%)
  const afaRate = form.permit === "yes" ? 0.05 : 0.27;

  // Fürdőszoba bruttó -> nettó
  if (form.extras.bathroom) {
    const bathroomGross = 1714500;
    const bathroomNet = bathroomGross / (1 + afaRate);
    netto += Math.round(bathroomNet);
  }

  // Konyha bruttó -> nettó
  if (form.extras.kitchen) {
    const kitchenGross = 1841500;
    const kitchenNet = kitchenGross / (1 + afaRate);
    netto += Math.round(kitchenNet);
  }

  // Padlófűtés
  if (form.extras.floorHeating) {
    netto += m2 * 20000;
  }

  // Redőny + szúnyogháló (átlag alapján, nem ablakfelület!)
  if (form.extras.blinds) {
    netto += m2 * 24000;
  }

  // Daruzás
  if (form.extras.crane) {
    netto += 400000;
  }

  // Szállítás
  if (form.distance && form.distance > 0) {
    netto += form.distance * 3000;
  }

  // Tervezési díj CSAK ha engedélyes ÉS tervezést is kér!
  if (form.permit === "yes" && form.design === "yes") {
    netto += m2 <= 50 ? m2 * 20000 : m2 * 15000;
  }

  // ÁFA és bruttó ár
  const afa = Math.round(netto * afaRate);
  const brutto = netto + afa;

  return { netto, afa, brutto };
}

